import * as types from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  allSpeakers: [],
  error: null,
};

const GetAllSpeakerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_SPEAKERS_REQUEST:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.GET_ALL_SPEAKERS_SUCCESS:
      return {
        ...state,
        loading: false,
        allSpeakers: action.payload,
      };
    case types.RESET_ALL_SPEAKERS_DATA:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default GetAllSpeakerReducer;
